import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import EmployeeImportFinalizeRequest from "../request/EmployeeImportJobFinalizeRequest";

const EmployeeImportJobFinalizeApiService = async (
  request: EmployeeImportFinalizeRequest
): Promise<boolean> => {
  const url = "/employeeimportjob/finalise/";
  const formData = new FormData();
  // eslint-disable-next-line
  // @ts-ignore
  Object.keys(request).forEach((it) => formData.append(it, request[it]));
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const { data } = await axios.post(url, formData, config);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployeeImportJobFinalizeApiService = () =>
  useMutation<boolean, AxiosError, EmployeeImportFinalizeRequest>(
    EmployeeImportJobFinalizeApiService,
    {
      mutationKey: ["EmployeeImportJobFinalizeApiService"],
    }
  );

export default useEmployeeImportJobFinalizeApiService;
